// connect global styles
import '@/styles/index.sass'
import 'vue-toastification/dist/index.css'
// import some bootstrap components
import { Dropdown } from 'bootstrap'
// core
import { createApp } from 'vue'
// plugins
import vfmPlugin from 'vue-final-modal' // vue modals plugin
import axios from 'axios' // requests plugin
import VueAxios from 'vue-axios' // helper for requests plugin
import VueEasyLightbox from 'vue-easy-lightbox'
import Toast from 'vue-toastification'

import ModalComponent from '@/components/app-modal'
import BreadcrumbsComponent from '@/components/app-breadcrumbs'
import router from './router.js'
import utils from './utils.js'
import appComponent from './app'

// make global
window._ = utils;

// create app
const app = createApp(appComponent);

// create global app config object
const appconf = {
	imagesHost: 'https://books.olit.su/',
	apiHost: 'https://books.olit.su/api/'
}

let user = null;

try {
	user = JSON.parse(localStorage.getItem('user'));
} catch (e) {
	user = null;
}

// create global user instance
appconf.user = user ? {
	id: user.id,
	token: user.token,
} : {
	id: null,
}

if (user) {
	// create axios instance for auth API requests
	const userapi = axios.create({
		baseURL: appconf.apiHost
	});

	// set Bearer auth token
	userapi.defaults.headers.common['Authorization'] = `Bearer ${user.token}`;

	// configure response for all requests
	userapi.interceptors.response.use(function (response) {
		// Any status code that lie within the range of 2xx cause this function to trigger
		// Do something with response data

		const data = response.data;

		if (data.error && typeof data.error === 'object' && Object.keys(data.error).length) {
			// есть ошибки валидации
			response.hasValidateErrors = true;
		} else {
			response.hasValidateErrors = false;
		}

		return response;
	}, function (error) {
		// Any status codes that falls outside the range of 2xx cause this function to trigger
		// Do something with response error
		// console.log('server error', error);
		return Promise.reject(error);
	});

	// make userapi global for vue
	app.config.globalProperties.userapi = userapi;
}

app.config.globalProperties.appconf = appconf;

app.config.globalProperties.picture = function(url, width, height) {

	if (width === void 0 && height === void 0) {
		return appconf.imagesHost + url;
	}

	const query = new URLSearchParams({
		src: url
	});

	width && query.append('w', width);
	height && query.append('h', height);

	return appconf.imagesHost + '/thumb.php?' + query.toString();
}

app.use(router);
app.use(VueAxios, axios);
app.use(VueEasyLightbox);
app.use(vfmPlugin);
app.use(Toast, {
	transition: 'Vue-Toastification__bounce',
	position: 'bottom-center',
	maxToasts: 20,
	newestOnTop: true,
	timeout: 5000,
	closeOnClick: false,
	pauseOnFocusLoss: true,
	pauseOnHover: true,
	draggable: true,
	draggablePercent: 0.6,
	showCloseButtonOnHover: false,
	hideProgressBar: false,
	closeButton: 'button',
	icon: true,
	rtl: false,
});

app
	.component('app-modal', ModalComponent)
	.component('app-breadcrumbs', BreadcrumbsComponent);

app.mount('#app');